import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { mainContentPadding } from '../../../../../v2BaseComponents/MainContentContainer';
import useOrganizationInvitationDefinitions from '../../../../../../hooks/api/useOrganizationInvitationDefinitions';
import InvitationDefinitionsTable from './InvitationDefinitionsTable';
import { View } from 'react-native';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';

export type InvitationDefinitionsTabOwnProps = {};

export type InvitationDefinitionsTabProps = InvitationDefinitionsTabOwnProps;

const InvitationDefinitionsTab: React.FC<InvitationDefinitionsTabProps> = () => {
    const { isLoadingInvitationDefinitions } = useOrganizationInvitationDefinitions({});
    const isMobile = useIsMobileLayout();

    return (
        <AnimateLoadedContent isLoading={isLoadingInvitationDefinitions}>
            {() => (
                <>
                    <View
                        style={{ width: '100%', height: '100%', paddingTop: isMobile ? undefined : mainContentPadding }}
                    >
                        <InvitationDefinitionsTable />
                    </View>
                </>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(InvitationDefinitionsTab);
